import { render } from "./MainCardsComp.vue?vue&type=template&id=839451aa&scoped=true&ts=true"
import script from "./MainCardsComp.vue?vue&type=script&lang=ts"
export * from "./MainCardsComp.vue?vue&type=script&lang=ts"

import "./MainCardsComp.vue?vue&type=style&index=0&id=839451aa&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\user\\Documents\\Code\\VSProjects\\modboxProject\\modbox\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-839451aa"]])

export default __exports__